import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=830aa9ce&scoped=true"
import script from "./customPage.vue?vue&type=script&lang=ts"
export * from "./customPage.vue?vue&type=script&lang=ts"
import style0 from "./customPage.vue?vue&type=style&index=0&id=830aa9ce&prod&lang=scss"
import style1 from "./customPage.vue?vue&type=style&index=1&id=830aa9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830aa9ce",
  null
  
)

export default component.exports